import { Audio } from 'expo-av';
import { BlurView } from 'expo-blur';
import React, { useState, useCallback } from 'react';
import { Image, Pressable, Text, View } from 'react-native';
import { useSafeAreaFrame } from 'react-native-safe-area-context';

import { styles } from './styles';

const QuestionCard = ({ setCorrects, setErrors, selectedObject, setSelectedObject, incrementAttempt }) => {
  const { width, height } = useSafeAreaFrame();
  const [hasClicked, setHasClicked] = useState(false);
  const [selectedAnswer, setSelectedAnswer] = useState('');

  const correctAnswer = selectedObject.answers?.filter((item) => item.correct === true)[0]?.text;

  const handleButtonPress = useCallback(
    async (item) => {
      setHasClicked(true);

      if (item === correctAnswer) {
        setCorrects((prevState) => ({ ...prevState, [selectedObject.object]: true }));
      } else {
        setErrors((prevState) => ({ ...prevState, [selectedObject.object]: true }));
      }

      // Increment attempt after answering
      incrementAttempt();

      setTimeout(() => {
        setSelectedObject(null);
      }, 1600);
    },
    [hasClicked, correctAnswer, selectedAnswer, selectedObject, incrementAttempt]
  );

  return (
    <View style={{ position: 'absolute' }}>
      <BlurView
        style={{
          height,
          width,
          position: 'absolute',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <View style={styles.container}>
          <Text style={styles.title}>{selectedObject.title}</Text>
          <Image style={styles.image} source={selectedObject.asset} />
          <Text style={styles.description}>{selectedObject.question}</Text>

          {selectedObject.answers.map((item, index) => (
            <Pressable
              key={index}
              onPress={() => {
                if (!hasClicked) {
                  setSelectedAnswer(item.text);
                  handleButtonPress(item.text);
                }
              }}
              style={[
                styles.button,
                {
                  backgroundColor:
                    hasClicked === true && correctAnswer === item.text
                      ? '#6BC041'
                      : selectedAnswer === item.text && selectedAnswer === item.text
                      ? '#BF5540'
                      : '#F0F0F0',
                  borderColor:
                    hasClicked === true && correctAnswer === item.text
                      ? '#559933'
                      : selectedAnswer === item.text && selectedAnswer === item.text
                      ? '#994433'
                      : '#d9d9d9',
                },
              ]}>
              <Text
                style={[
                  styles.textLetter,
                  {
                    color:
                      (hasClicked === true && selectedAnswer === item.text) ||
                      (hasClicked === true && correctAnswer === item.text)
                        ? '#ffffff'
                        : '#1F647A',
                  },
                ]}>
                {item.letter}
              </Text>
              <Text
                style={[
                  styles.textAnswers,
                  {
                    color:
                      (hasClicked === true && selectedAnswer === item.text) ||
                      (hasClicked === true && correctAnswer === item.text)
                        ? '#ffffff'
                        : '#000000',
                  },
                ]}>
                {item.text}
              </Text>
            </Pressable>
          ))}
        </View>
      </BlurView>
    </View>
  );
};

export default QuestionCard;
